import React from 'react';
import {
    ModalFooter,
    Text,
    Button,
    VStack,
    Popover,
    PopoverArrow,
    PopoverBody,
    PopoverContent,
    PopoverTrigger,
} from '@chakra-ui/react';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { ThemeTokens, FaIcon } from '@acp/core-ui';
import { ReportedFindingDataMachine } from '@acp/shared';
import { ReportedFindingsMachineContext } from './machine/context';
import { ReportedFindingsWizardTable } from './components/table/reported-findings-wizard-table';

function SelectButton({
    reportedFinding,
}: {
    reportedFinding: ReportedFindingDataMachine;
}) {
    const machine = ReportedFindingsMachineContext.useActorRef();

    const selectedProblemRegisterIds = ReportedFindingsMachineContext.useSelector(
        (state) => state.context.thirdPartyResolutionForm.selectedProblemRegisterIds
    );

    const { problemRegisterId, thirdPartyInvalidStatus } = reportedFinding.problemRegister;
    const toggled = selectedProblemRegisterIds.includes(problemRegisterId);
    const handleToggle = () => {
        machine.send({
            type: 'TOGGLE_REPORTED_FINDING',
            reportedFindingId: problemRegisterId,
        });
    };

    if (thirdPartyInvalidStatus === true) {
        return (
            <Popover isLazy trigger="hover" placement="auto">
                <PopoverTrigger>
                    <Text color="muted.300" fontWeight="medium" fontSize="sm">
                        Unable to be resolved
                        <FaIcon icon={faCircleInfo} ml={1} />
                    </Text>
                </PopoverTrigger>
                <PopoverContent>
                    <PopoverArrow />
                    <PopoverBody>
                        <VStack alignItems="flex-start" gap={0}>
                            <Text fontSize="small">
                                Detector Inspector is unable to resolve this reported
                                finding.
                            </Text>
                        </VStack>
                    </PopoverBody>
                </PopoverContent>
            </Popover>
        );
    }

    if (toggled) {
        return (
            <Button
                onClick={handleToggle}
                borderRightWidth={1}
                colorScheme="secondary"
                variant="solid"
                size="sm"
            >
                Selected
            </Button>
        );
    }

    return (
        <Button
            onClick={handleToggle}
            colorScheme="secondary"
            background="white"
            borderRightWidth={1}
            borderRightColor="secondary.900"
            borderColor={ThemeTokens.Defaults.borderColor}
            color="muted.700"
            bgColor="white"
            variant="outline"
            size="sm"
        >
            Select
        </Button>
    );
}

function ResolvedByThirdPartySelect() {
    const machine = ReportedFindingsMachineContext.useActorRef();

    const selectedProblemRegisterIds = ReportedFindingsMachineContext.useSelector(
        (state) => state.context.thirdPartyResolutionForm.selectedProblemRegisterIds
    );

    return (
        <VStack align="left" w="100%" gap={0} mb={4}>
            <VStack w="100%" alignItems="stretch" gap={6}>
                <Text fontSize="md" fontWeight="medium">
                    Mark as resolved by third-party
                </Text>
                <Text fontSize="md">
                    Please select the findings that have been resolved by a third-party.
                    Documentation relating to the resolution can be attached
                    for the selected findings in the following screen.
                </Text>
            </VStack>
            <ReportedFindingsWizardTable>
                {(item) => (
                    <SelectButton
                        reportedFinding={item}
                    />
                )}
            </ReportedFindingsWizardTable>
            <ModalFooter justifyContent="space-between">
                <Button
                    colorScheme="muted"
                    variant="ghost"
                    onClick={() => { machine.send({ type: 'BACK' }); }}
                >
                    Back
                </Button>
                <Button
                    colorScheme="purple"
                    variant="solid"
                    onClick={() => { machine.send({ type: 'CONTINUE' }); }}
                    disabled={selectedProblemRegisterIds.length === 0}
                >
                    Next
                </Button>

            </ModalFooter>
        </VStack>
    );
}

export { ResolvedByThirdPartySelect };
